import callAPiBase from './base';

const firstReplyChartApi = {
  list: ({
    startDate,
    endDate,
    data,
  }: {
    startDate: number;
    endDate: number;
    data: object;
  }) =>
    callAPiBase({
      endpoint: `/api/reports/attendants/reply?startDate=${startDate}&endDate=${endDate}`,
      method: 'POST',
      useToken: true,
      data,
    }),
  listScatter: ({
    startDate,
    endDate,
  }: {
    startDate: number;
    endDate: number;
  }) =>
    callAPiBase({
      endpoint: `/api/reports/attendants/reply/scatter?startDate=1614018490475&endDate=1614623290475`,
      method: 'GET',
      useToken: true,
    }),
};

export { firstReplyChartApi };
export default firstReplyChartApi;
